import { Box, Textfield } from '@simplywallst/ui-core';
import { useState, useEffect } from 'react';
import { useDebounce } from '@simplywallst/hooks/useDebounce';

interface Props {
  keywords?: string;
  onChange: (keywords: string) => void;
}

export function KeywordSearch({ keywords, onChange }: Props) {
  /**
   * TODO: retain keyword search from saved screeners
   */
  const [query, setQuery] = useState(keywords);
  const debouncedSearch = useDebounce(query, 800);

  useEffect(() => {
    if (typeof debouncedSearch === 'string') {
      onChange(debouncedSearch);
    }
  }, [debouncedSearch, onChange]);

  return (
    <Box
      boxShadow="subtleBorder"
      backgroundColor="noir"
      borderRadius="x1spacePx"
      padding="x1spacePx"
      marginTop="x2spacePx"
    >
      <Textfield
        label="Keyword"
        type="search"
        placeholder="e.g. nuclear power, GPU, self driving cars, solar"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
    </Box>
  );
}
